import { type ReactNode } from 'react'

import PlainTooltip from 'app/common/ui-next/plain-tooltip'

type Props = {
  className?: string
  children?: ReactNode
}

const CellContentOverflow = ({ className, children }: Props) => {
  if (!children) {
    return null
  }

  return (
    <PlainTooltip content={children} className={className}>
      {children}
    </PlainTooltip>
  )
}

export default CellContentOverflow
